import { defineMessages } from 'react-intl';

export default defineMessages({
    errorTitle: {
        id: 'ml.quoteandbind.pa.veracityCheck.errorTitle',
        defaultMessage: 'Something went wrong processing additional details'
    },
    errorDescription: {
        id: 'ml.quoteandbind.pa.veracityCheck.errorDescription',
        defaultMessage: 'Please try again.'
    },
    validateInformation: {
        id: 'ml.quoteandbind.pa.veracityCheck.Validate Information',
        defaultMessage: 'Validate Information'
    }
});
